import { i18n } from "translate/i18n";

export const forgotPassword = i18n.t("messages.forgotPassword");
